/* eslint-disable */
export default {
  _cartoon_pop2: 'cartoon_pop2',
  _cartoon_win: 'cartoon_win',
  _cartoon_slide_flip: 'cartoon_slide_flip',
  _click: 'click',
}